import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var NodeText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n"], ["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n"])));
var templateObject_1;
//# sourceMappingURL=Text.js.map